{
  "meta": {
    "title": "Log in · Cycling Zone",
    "description": "Log in to Cycling Zone or create a free manager account. Build a team, bid for riders in live auctions, and race a full season."
  },
  "page": {
    "title": "Cycling Zone",
    "subtitle": {
      "login": "Log in to continue",
      "signup": "Create your manager account",
      "forgot": "Get a link to reset your password"
    },
    "tagline": "Cycling Zone · Multiplayer Edition"
  },
  "context": {
    "title": "Create a free manager to continue",
    "body": "You followed a link into the game. Sign up free to see it. No pay-to-win, ever."
  },
  "field": {
    "teamName": {
      "label": "Team name",
      "placeholder": "e.g. Dolmer Racing",
      "help": "3-30 characters. This becomes your in-game team name"
    },
    "managerName": {
      "label": "Manager name",
      "placeholder": "e.g. Nicolai Hansen",
      "help": "Your name as manager, shown on your team profile"
    },
    "email": {
      "label": "Email",
      "placeholder": "you@email.com",
      "forgotHelp": "I'll send a secure reset link to this email.",
      "signupHelp": "Your confirmation link is sent here, so double-check the spelling.",
      "didYouMeanCta": "Did you mean {suggestion}?"
    },
    "password": {
      "label": "Password",
      "help": "At least 6 characters"
    },
    "newPassword": {
      "label": "New password",
      "help": "At least 6 characters"
    },
    "confirmPassword": {
      "label": "Repeat new password"
    }
  },
  "submit": {
    "login": {
      "idle": "Log in",
      "loading": "Logging in..."
    },
    "signup": {
      "idle": "Create account and team",
      "loading": "Creating account and team..."
    },
    "forgot": {
      "idle": "Send reset link",
      "loading": "Sending reset link..."
    },
    "savePassword": {
      "idle": "Save new password",
      "loading": "Saving new password..."
    }
  },
  "switch": {
    "forgot": "Forgot password?",
    "signup": "No account? Sign up here",
    "login": "Already have an account? Log in",
    "backToLogin": "Back to login"
  },
  "error": {
    "invalidCredentials": "Wrong email or password",
    "teamNameTooShort": "Team name must be at least 3 characters",
    "managerNameTooShort": "Manager name must be at least 2 characters",
    "teamNameTaken": "That team name is already taken. Pick another.",
    "bootstrapFailed": "Account created, but the team could not be initialised: {detail}",
    "sessionExpired": "Session expired. Reload the page and try again.",
    "connectionFailed": "Couldn't reach the server. Check your connection and try again.",
    "unknown": "Something went wrong. Try again.",
    "passwordTooShort": "Password must be at least 6 characters",
    "passwordMismatch": "Passwords don't match",
    "resetLinkExpired": "The reset link has expired or is invalid. Request a new one from the login page.",
    "resetLinkInactive": "This reset link is no longer active."
  },
  "success": {
    "forgotTitle": "I've sent a reset link to your email.",
    "forgotBody": "Open the email and follow the reset link to choose a new password.",
    "signupPartial": "Account created. Log in to finish setting up your team.",
    "signupBody": "Check your email to confirm your account, then log in.",
    "confirmTitle": "Almost there. Confirm your email.",
    "confirmSentTo": "I sent a confirmation link to",
    "confirmNext": "Open it and click the link to activate your account. It usually arrives within a minute.",
    "confirmSpam": "Nothing in your inbox? Have a look in the spam folder.",
    "confirmKeepOpen": "Your team name and manager name are saved, so you won't have to fill anything in again.",
    "resendPrompt": "Didn't get it?",
    "resendCta": "Send it again",
    "resendSending": "Sending…",
    "resendSent": "Sent. Check your inbox (and spam folder).",
    "resendCooldown": "You can send a new link in {seconds}s",
    "wrongEmailPrompt": "Typed the wrong address?",
    "wrongEmailCta": "Change your email",
    "signupCta": "Go to login",
    "joinDiscord": "New here? Meet other managers and get help on our Discord.",
    "joinDiscordCta": "Join our Discord",
    "passwordUpdatedTitle": "Your password has been updated.",
    "passwordUpdatedBody": "You can continue straight into the game with your new password.",
    "passwordUpdatedCta": "Go to dashboard"
  },
  "resetPassword": {
    "title": "Reset password",
    "subtitle": "Choose a new password for your manager account",
    "linkExpiredHelp": "Request a new reset link from the login page and open the email again."
  },
  "setupWizard": {
    "title": "Welcome to Cycling Zone",
    "subtitle": "Name your team to get started",
    "teamNamePlaceholder": "e.g. Team Nordic",
    "managerNamePlaceholder": "e.g. Lars Hansen",
    "submitIdle": "Create team and start",
    "submitLoading": "Saving…",
    "footnote": "You can change the names later under Profile & Settings"
  },
  "onboardingModal": {
    "eyebrow": "Get started",
    "title": "Your team is ready. What now?",
    "subtitle": "Here are the three most important things to know:",
    "cards": {
      "market": {
        "title": "Market",
        "desc": "Browse all available riders and filter by stats and price. Start an auction to bring in your first rider.",
        "cta": "Go to Market"
      },
      "auctions": {
        "title": "Auctions",
        "desc": "Follow active auctions, bid on other teams' riders, and watch your own. Winners are drawn automatically.",
        "cta": "See Auctions"
      },
      "board": {
        "title": "Board",
        "desc": "The board judges you continuously based on team quality and results. Keep satisfaction high to avoid pressure.",
        "cta": "Open Board"
      }
    },
    "help": "Help & Rules",
    "dismiss": "Got it",
    "closeAria": "Close"
  },
  "onboardingTour": {
    "ariaLabel": "Onboarding tour",
    "fallback": "Tour active. Couldn't find a tour target on this page.",
    "end": "End tour",
    "skip": "Skip",
    "next": "Next",
    "done": "Done"
  },
  "footer": {
    "privacyPolicy": "Privacy policy",
    "terms": "Terms of sale"
  },
  "linkError": {
    "title": "That confirmation link has expired",
    "body": "Confirmation links are only valid for a short time. Enter your email below and send yourself a fresh link, or log in if your account is already confirmed.",
    "resendCta": "Send a fresh link"
  }
}
